import { render } from "./NewsCreatePreview.vue?vue&type=template&id=13c1daef&scoped=true"
import script from "./NewsCreatePreview.vue?vue&type=script&lang=js"
export * from "./NewsCreatePreview.vue?vue&type=script&lang=js"

import "./NewsCreatePreview.vue?vue&type=style&index=0&id=13c1daef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c1daef"]])

export default __exports__